

// copied from air/experience react app

export default class Api {

  /**
   * you can set an endpoint prefix,
   * so you don't have to keep providing it with every call
   * @type {string}
   */
  requestPrefix = '';

  constructor(host) {
    //this.host = process.env.REACT_APP_HTTP_API_URL;

    // TEMPORARY HOST for Doug's 'wrapper' API on labs server
    this.host = 'https://labs.impactinternational.com/nitroapi/?api/nitro'
  }



  /**
   * @param {string} endPoint
   * @param {int} timeout
   * @returns {Promise<Response | never>}
   */
  get(endPoint, timeout = 2500) {
    //console.log('Api::get', endPoint, timeout);
    var uri = this.host + '/' + endPoint;
    return fetch(uri, {
      method: 'GET',
      timeout: timeout,
      headers: {
      }
    })
      .catch((error) => {
        console.warn(error);
        throw new Error(error.status);
      });
  }

  /**
   * @param {string} endPoint
   * @param {{}} data
   * @param {int} timeout
   * @param {?} rawData - not accounted for yet
   * @returns {Promise<Response | never>}
   */
  post(endPoint, data, timeout = 2500, rawData = false) {
    //console.log('Api::post', endPoint, timeout);
    try {
      var uri = this.host + '/' + endPoint;
      return fetch(uri, {
        method: 'POST',
        timeout: timeout,
        body: JSON.stringify(data)
      })
        .catch((error) => {
          console.error(error);
          throw new Error(error.status);
        });
    }
    catch (error) {
      console.error(error);
    }
  }

  /**
   * @param {string} endPoint
   * @param {int} timeout
   * @returns {Promise<Response | never>}
   */
  delete(endPoint, timeout = 2500) {
    //console.log('Api::delete', endPoint, timeout);
    try {
      var uri = this.host + '/' + endPoint;
      return fetch(uri, {
        method: 'DELETE',
        timeout: timeout
      })
        .catch((error) => {
          console.error(error);
          throw new Error(error.status);
        });
    }
    catch (error) {
      console.error(error);
    }
  }

  /**
   * @param {string} endPoint
   * @param {{}} data
   * @param {int} timeout
   * @param {?} rawData - not accounted for yet
   * @returns {Promise<Response | never>}
   */
  request(verb, endPoint, data = null, timeout = 2500, rawData = false) {
    console.log('Api::request', verb, endPoint, data, timeout, rawData);

    try {
      var uri = this.host + '/' + endPoint;
      return fetch(uri, {
        method: verb,
        timeout: timeout,
        body: rawData ? data : JSON.stringify(data)
      })
        .catch((error) => {
          console.error(error);
          throw new Error(error.status);
        });
    }
    catch (error) {
      console.error(error);
    }
  }
}
